import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Col,
  Row,
  FormGroup,
} from "react-bootstrap";
import FormErrorBlock from '../../../components/FormErrorBlock';
import Select from 'react-select';

import { isInAppBrowser, numberFormatter } from '../../../helpers';
import { jumpTo, getAgentPath } from '../../../helpers';
import BasePage from '../../../components/BasePage';
import Passengers from '../../CheckoutPage/Passengers';
import { Button } from 'react-bootstrap';
import { ls } from '../../../locale';
import { getLastFlightDate } from '../../CheckoutPage/helper';
import { bookingActions } from '../../../state/ducks/booking';
import { mmbActions } from '../../../state/ducks/mmb';
import { flightActions } from '../../../state/ducks/flights';

const defaultInfant = {
  title: 'MISS',
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  paxTypeName: 'Infant',
  paxType: 5
}

function InfantPage({booking, getBookingWithSummary, getFareQuoteForInfant, addInfant}) {


  const passengersComponent = useRef(null);
  const [fareQuote, setFareQuote] = useState(null);
  const [travelWithError, setTravelWithError] = useState(null);
  const [travelWith, setTravelWith] = useState(null);


  const rButton = ls.t('Button');
  const rSummaryPage = ls.t('MMB.SummaryPage');
  const inAppBrowser = isInAppBrowser();

  useEffect(() => {
    if (!booking?.pnr) getBookingWithSummary();
  }, [booking])


  useEffect(() => {
    if(booking?.pnr) {
      getFareQuoteForInfant().then(response => {
        setFareQuote(response)
      });
    }
  }, [booking])

  const confirm = () => {
    const isPassengersValid = passengersComponent.current.validateForm();
    if(!isPassengersValid) return;

    if(booking.isGroupBooking && !travelWith) {
      setTravelWithError(rSummaryPage.TravelWithError);
      return;
    }

    const passengerData = passengersComponent.current.getFormValues();
    if (!passengerData || passengerData.length === 0) {
      return;
    }

    // console.log('passengerData', passengerData);
    const infants = passengerData.map(p=> ({
      title: p.title,
      firstName: p.firstName,
      lastName: p.lastName,
      dateOfBirth: p.dateOfBirth,
      travelWithAdultId: travelWith
    }))

    addInfant({infants}).then(response => {
      if(response?.success) {
        jumpTo(getAgentPath() + '/mmb/summary');
      }
    })
    
  }

  const handleTravelWithChange = (selectedOption) => {
    if (selectedOption) {
      setTravelWith(selectedOption.value);
      setTravelWithError(null);
    }
  }

  if(!booking?.pnr) {
    return (
      <BasePage mainContainerClass='passenger padt40'>
        <div className='min-height'>
          loading...
        </div>
      </BasePage>
    );
  }

  const currencyCode = fareQuote?.currencyCode;
  const amountSplit = fareQuote?.totalFare > 0 
    ? numberFormatter.decimalSplitter(numberFormatter.formatCurrency(fareQuote.totalFare))
    : null;
  

  const lapChildIds = booking.passengers.filter(p => p.lapChildId > 0).map(p => p.lapChildId);
  const adults = booking.passengers
  .filter(p => p.paxType === 1 && !lapChildIds.includes(p.id))
  .map(p => ({
    value: p.id,
    label: `${p.title} ${p.firstName} ${p.lastName}`
  }));

  return (
    <BasePage mainContainerClass='passenger padt40'>
      <div className='min-height'>
        <h1>{rSummaryPage.AddInfant}</h1>

        <Passengers ref={passengersComponent}
          isHideTitle={true}
          passengers={[defaultInfant]}
          flightDate={getLastFlightDate(booking) ?? new Date()}
        />

        {booking.isGroupBooking && <Row className="tw-mb-10">
          <Col xs={12} md={4}>
            {rSummaryPage.TravelWith}
            <FormGroup>
              <div className='country-select'>
                <Select className="country-control" placeholder={rSummaryPage.TravelWithPlaceHolder} options={adults} 
                  onChange={handleTravelWithChange}
                />
              </div>
              <FormErrorBlock error={travelWithError} />
            </FormGroup>
          </Col>
        </Row>}

        <div className='clearfix btnCon'>
          {!inAppBrowser && <Button type="submit" className="btn btn-primary pull-left flip btn-cancel btn-effect"
            onClick={() => jumpTo(getAgentPath() + '/mmb/summary')}>
            <span><i className="picon picon-btn-arrow-left-w" />{rButton.Back}</span>
          </Button>}

          <Button type="submit" className="btn btn-primary pull-right flip btn-submit btn-effect"
            onClick={() => confirm()}><span>{rButton.Confirm}
              <i className="picon picon-btn-arrow-right-w" /></span>
          </Button>

          {amountSplit && <div className="bottom-total pull-right">
            <label>{rSummaryPage.InfantCharge}</label>
            <p>
              <span className="currency">{currencyCode} </span>
              {amountSplit.amount}
              <span className={`${currencyCode} decimal-point`}>
                {
                  numberFormatter.oneDecimalPoint(amountSplit.decimal, currencyCode)
                }
              </span>
            </p>
          </div> }
        </div>
      </div>
    </BasePage>
  );
}


function mapStateToProps(state) {
  return {
    booking: state.booking.details
  };
}

const mapDispatchToProps = {
  getBookingWithSummary: bookingActions.getBookingWithSummary,
  addInfant: mmbActions.addInfant,
  getFareQuoteForInfant: flightActions.getFareQuoteForInfant,
}

export default connect(mapStateToProps, mapDispatchToProps)(InfantPage);